import http from './http';

export default {
  getBots() {
    return http.get('/bots');
  },
};
